import CustomerLimitReachedAlert from "./CustomerLimitReachedAlert";
import type { CustomerLimitGuardResult } from "./useCustomerLimitGuard";

interface CustomerLimitGuardAlertProps {
  limitGuard: CustomerLimitGuardResult;
}

const CustomerLimitGuardAlert = ({ limitGuard }: CustomerLimitGuardAlertProps) => {
  if (!limitGuard.isLimitReached) return null;

  return (
    <CustomerLimitReachedAlert title={limitGuard.title} description={limitGuard.description} />
  );
};

export default CustomerLimitGuardAlert;
